import { setSessionStorageItem, removeSessionStorageItem } from './minutesLocalStore'

//Transient storage (wiped if user refreshes browser)
//If the items are gone from transitory storage we reload them from server.
export const transientStorageManager: TransientStorageManager = {
    _selectedMinuteItem: undefined,
    timeZones: [],
    currentTimezone: '',
    isDateInputMaskUS: true,
    dateFormatInput: '',
    dateFormat: '',
    timeFormat: '',
    platform: null,
    siteName: '',
    companyName: '',
    linkedBookDetails: null,
    linkedBookError: null,
    createForBook: null,
    committeeName: null,
    allContacts: null,
    allBooks: new Map(),
    currentUser: null,
    clientTitle: '',
    linkedBookId: null,
    book_summarization_enabled: false,
    writing_style_enabled: false,
    view_writing_style: false,
    complete_unlinked_actions: false,
    get selectedMinuteItem() {
        return this._selectedMinuteItem
    },
    set selectedMinuteItem(item) {
        this._selectedMinuteItem = item

        //Save just the selectedMinutesId is sessionStorage
        if (item) {
            setSessionStorageItem('selectedMinuteItemId', item.id)
        } else {
            removeSessionStorageItem('selectedMinuteItemId')
        }
    },
    logo_blob: '',
    parentAppUrl: '',
    reminderUserDefaults: null
}

type TransientStorageManager = {
    allContacts: any | null
    allBooks: Map<any, any>
    clientTitle: any
    committeeName: any | null
    createForBook: any | null
    currentTimezone: string
    currentUser: Contact | null
    dateFormat: string
    dateFormatInput: string
    isDateInputMaskUS: boolean
    linkedBookDetails: any | null
    linkedBookError: any | null
    linkedBookId: string | null
    platform: Platform | null
    _selectedMinuteItem: any
    selectedMinuteItem: any
    siteName: string
    companyName: string
    timeFormat: string
    timeZones: any[]
    logo_blob: string | null
    parentAppUrl: string
    book_summarization_enabled: boolean
    writing_style_enabled: boolean
    view_writing_style: boolean
    complete_unlinked_actions: boolean
    reminderUserDefaults: any | null
}
